import React, { Component } from "react";
import { BoxDanger, MnemoCallout, MnemoLoading, ModalHandler, SupportoTecnico, Title } from "components/misc";
import { Button, Container, Col, Row, Card, CardBody } from "design-react-kit";
import { networkErrorHelper } from "libs";
import { revisionService } from "libs/api/revisionService";
import { withRouter } from "react-router-dom";
import { MTextArea } from "components/forms";

class ReviewDetailSecurity extends Component {
  state = {
    loading: true,
    loadingError: false,
    lessonActivity: "",
    idLessonActivity: 0,
    revisionNote: "",
    revisionNoteError: false,
  };

  componentDidMount() {
    const idLessonActivity = parseInt(this.props.match.params.idLessonActivity) > 0 ? this.props.match.params.idLessonActivity : 0;
    this.setState({ idLessonActivity });
    this.loadRemote(idLessonActivity);
  }

  loadRemote(idLessonActivity) {
    revisionService
      .getLessonActivity(idLessonActivity)
      .then(({ data }) => {
        const { user, course, userCourse, lessonActivity, lessonActivityDetail } = data.payload;

        this.setState(() => ({
          loading: false,
          user,
          course,
          userCourse,
          lessonActivity,
          lessonActivityDetail,
        }));
      })
      .catch((error) => {
        if (networkErrorHelper.is404(error)) {
          this.pendingDraft = true;
        } else {
          networkErrorHelper.notify(error);
          this.setState({
            loadingError: true,
            loading: false,
          });
        }
      });
  }

  goBack() {
    window.history.back();
  }

  handleRevision(status) {
    const { idLessonActivity, revisionNote } = this.state;

    const payload = { idLessonActivity, status, revisionNote };

    revisionService
      .updateLessonActivitySecurity(payload)
      .then(() => {
        this.goBack();
      })
      .catch((error) => {
        console.error(error);
        networkErrorHelper.notify(error);
      });
  }

  toggleValid = () => {
    ModalHandler.show(null, "Conferma validità attestato", "Sei sicuro di voler contrassegnare questo attestato come VALIDO?", null, () =>
      this.handleRevision("download"),
    );
  };

  toggleNotValid = () => {
    ModalHandler.show(null, "Conferma non validità attestato", "Sei sicuro di voler contrassegnare questo attestato come NON VALIDO?", null, () =>
      this.handleRevision("securityPending"),
    );
  };

  render() {
    const { lessonActivityDetail, lessonActivity, user, userCourse, course, revisionNote, revisionNoteError, loading, loadingError } = this.state;
    const files = lessonActivityDetail?.filter((activity) => activity.fileUrl && activity.code === "attestatoSicurezza");
    const { status } = lessonActivity;

    return (
      <>
        <section className="my-4">
          {loading ? (
            <MnemoLoading />
          ) : loadingError ? (
            <BoxDanger className="m-5">
              Si è verificato un errore durante l'elaborazione della richiesta, se il problema persiste puoi <SupportoTecnico />
            </BoxDanger>
          ) : (
            <Container>
              <Title>Revisione - Attestato sulla sicurezza</Title>
              <Col lg={{ size: 12 }} className="text-right">
                <Button onClick={this.goBack} color="btn btn-primary bg-dark m-2 p-3">
                  Torna Indietro
                </Button>
              </Col>

              <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                <div className="flag-icon" />
                <CardBody>
                  <b>Nome</b>: {user.name}
                  <br />
                  <b>Cognome</b>: {user.surname}
                  <br />
                  <b>Email</b>: {user.email}
                  <br />
                  <b>Codice Registrazione</b>: {userCourse.registrationCode}
                  <br />
                  <b>Titolo corso</b>: {course.title}
                  <br />
                  <b>Codice corso</b>: {course.code}
                </CardBody>
              </Card>

              <Card tag="div" className="card-bg card-big rounded border-bottom-card mb-4">
                <div className="flag-icon" />
                <CardBody>
                  <span
                    className={`
                  badge m-3 p-2 ${status === "securityToApprove" ? "badge-warning" : "badge-success"}`}
                  >
                    {status === "securityToApprove" ? "In attesa di approvazione" : "Approvato"}
                  </span>

                  {files && files.length > 0 && (
                    <MnemoCallout className="mnemo-callout-info">
                      {files.map((activity, index) => (
                        <Row key={`file-${index}`} className="align-items-center mb-2">
                          <Col>
                            <p className="mb-0">
                              <b>Attestato sulla sicurezza: </b>
                              <a href={`${process.env.REACT_APP_API_URL}${activity.fileUrl}`} target="_blank" rel="noopener noreferrer">
                                {" "}
                                Visualizza file
                              </a>
                            </p>
                          </Col>
                        </Row>
                      ))}
                    </MnemoCallout>
                  )}

                  {status === "securityToApprove" && (
                    <>
                      <Row className="my-4 justify-content-end">
                        <Col xs="12" className="mb-3">
                          <MTextArea
                            label="Eventuali note revisione da inviare allo studente (facoltativo)"
                            rows="5"
                            value={revisionNote}
                            invalid={revisionNoteError}
                            onChange={(index, value) =>
                              this.setState({
                                revisionNote: value,
                                revisionNoteError: false,
                              })
                            }
                          />
                        </Col>
                      </Row>
                      <Row className="my-4 justify-content-end">
                        <Col xs="auto">
                          <Button color="primary" className="m-2" onClick={this.toggleValid}>
                            Attestato VALIDO
                          </Button>
                        </Col>
                        <Col xs="auto">
                          <Button color="danger" className="m-2" onClick={this.toggleNotValid}>
                            Attestato NON VALIDO
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Container>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewDetailSecurity);
